import script from "./AliensList.vue?vue&type=script&setup=true&lang=js"
export * from "./AliensList.vue?vue&type=script&setup=true&lang=js"

import "./AliensList.vue?vue&type=style&index=0&id=f6d1258e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6d1258e"]])

export default __exports__